/**
 * PaymentCancel — v3.0.140
 * Landing page when the user aborts the Stripe Checkout flow.
 * No charge was made; just link them back to buy or the dashboard.
 */
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import MainNav from '../components/MainNav';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="payment-cancel-page">
      <MainNav />
      <div className="max-w-md mx-auto pt-24 px-4 text-center">
        <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-zinc-800 flex items-center justify-center">
          <XCircle className="text-zinc-400" size={40} />
        </div>
        <h1 className="text-2xl font-bold mb-2">Payment canceled</h1>
        <p className="text-sm text-zinc-400 mb-6">
          No worries — your card was not charged. You can come back anytime.
        </p>
        <div className="flex flex-col gap-2">
          <Link to="/dashboard?buyCredits=true">
            <Button className="w-full bg-emerald-500 text-black hover:bg-emerald-400" data-testid="payment-cancel-retry-btn">
              Try again
            </Button>
          </Link>
          <Link to="/dashboard" className="text-sm text-zinc-400 hover:text-white mt-2">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
